import {TaskType} from '@toolify/client/src/stores/TaskStore/enum/TaskType'
import {ITaskTypeStrategy} from '@toolify/client/src/stores/TaskStore/strategies/ITaskTypeStrategy'
import {ITaskItem} from '@toolify/client/src/stores/TaskStore/types/ITaskItem'

export const GenericTaskTypeStrategy: ITaskTypeStrategy<TaskType.Generic> = {
  type: TaskType.Generic,
  calculateTaskTime(task: ITaskItem<TaskType.Generic>, otherTasks: ITaskItem[], params) {
    return null
  },
}

